import React from 'react';
import ReactDOM from 'react-dom/client';
import './input.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TripProgress from './driverDashboard/template/TripProgress';
import ContentUnavailable from './unavailable';
import TripDetails from './driverDashboard/template/TripDetails';
import {
  AuthVerify,
  RegisterCustomer,
  RegisterDriver,
  Login,
  UserProfile,
  ForgotPassword,
  ResetPassword,
  HomeDashboard,
  Chat,
  Support,
  SelectionPage,
  Package,
  ConfirmTrip,
  Notification,
  Earnings,
  LandingPage,
  AboutUs,
  RideSummary,
  TermsAndCondtions,
  Privacy,
  Feedback,
  Success,
  Cancel,
  CustomerTripProgress,
  CancelReasonPage,
  ReviewPendingPage,
  TripCompletedPage,
  CustomerWelcomePage
} from './App';

import { AuthProvider, useAuth } from './context/AuthContext';
import { LoaderProvider } from './context/LoaderContext';
import Loader from './Loader/Loader';
import { store, persistor } from './store/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

/**
 * PrivateRoute guards protected routes by checking authentication state from context.
 */
const PrivateRoute = ({ children }) => {
  const { auth, loading } = useAuth();
  if (loading) {
    return <Loader />;
  }

  return auth.isAuthenticated ? children : <Navigate to="/login" replace />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AuthProvider>
            <LoaderProvider>
              <Loader />
              <ToastContainer />
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/auth-verify/" element={<AuthVerify />} />
                <Route path="/selection/" element={<SelectionPage />} />
                <Route path="/registration/personal/" element={<RegisterCustomer />} />
                <Route path="/registration/business/" element={<RegisterDriver />} />
                <Route path="/welcome-customer/" element={<CustomerWelcomePage />} />
                <Route path="/review-pending/" element={<ReviewPendingPage />} />
                <Route path="/forgot-password/" element={<ForgotPassword />} />
                <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
                <Route path="/profile/" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
                <Route path="/dashboard/" element={<PrivateRoute><HomeDashboard /></PrivateRoute>} />
                <Route path="/package/" element={<PrivateRoute><Package /></PrivateRoute>} />
                <Route path="/" element={<LandingPage />} />
                <Route path="/about-us/" element={<AboutUs />} />
                <Route path="/terms-and-conditions/" element={<TermsAndCondtions />} />
                <Route path="/privacy-policy/" element={<Privacy />} />
                <Route path="/support/" element={<PrivateRoute><Support /></PrivateRoute>} />
                <Route path="/chat/" element={<PrivateRoute><Chat /></PrivateRoute>} />
                <Route path="/confirm-trip" element={<PrivateRoute><ConfirmTrip /></PrivateRoute>} />
                <Route path="/notifications/" element={<PrivateRoute><Notification /></PrivateRoute>} />
                <Route path="/payment-success" element={<PrivateRoute><Success /></PrivateRoute>} />
                <Route path="/payment-cancel" element={<PrivateRoute><Cancel /></PrivateRoute>} />
                <Route path="/feedback/" element={<Feedback />} />
                <Route path="/driver-dashboard/" element={<PrivateRoute><RideSummary /></PrivateRoute>} />
                <Route path="/trip-progress/" element={<PrivateRoute><TripProgress /></PrivateRoute>} />
                <Route path="/customer-trip/" element={<PrivateRoute><CustomerTripProgress /></PrivateRoute>} />
                <Route path="/available-trips/" element={<PrivateRoute><TripDetails /></PrivateRoute>} />
                <Route path="/driver/cancel-reason/:tripReference" element={<CancelReasonPage />} />
                <Route path="/driver/trip-completed" element={<TripCompletedPage />} />
                <Route path="/earnings/" element={<PrivateRoute><Earnings /></PrivateRoute>} />
                <Route path="*" element={<ContentUnavailable />} />
              </Routes>
            </LoaderProvider>
          </AuthProvider>
        </BrowserRouter>
        </PersistGate>
      </Provider>
    </React.StrictMode>
);
